import { AppOfferListItem } from 'state/loyalty/types';

function compareAvailability(a: AppOfferListItem, b: AppOfferListItem): number {
  const aIsUnavailable = Boolean(a.inlineAlertMessage);
  const bIsUnavailable = Boolean(b.inlineAlertMessage);

  if (aIsUnavailable === bIsUnavailable) {
    return 0;
  }
  return aIsUnavailable ? 1 : -1;
}

export function sortOfferListItemsByAvailability(
  offerListItems: AppOfferListItem[]
): AppOfferListItem[] {
  return [...offerListItems].sort(compareAvailability);
}
